import React, { Component } from "react";
import "./Footer.css";

const Footer = () => {
  return <div>&nbsp;</div>;
}

export default Footer;
